import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem 0;
`;

export const NoLinks = styled(Container)`
  text-align: center;
`;

export const EditMappingForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
